module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-14-76ecf67c19e5fb85b77fe700cc8f3cb7.jpg";